import Banner from "../utilities/Banner/Banner";
import { Container, Box, Grid } from "@mui/material";
import { Content } from "./Content";
import TabPannel from "../utilities/Tab/TabPannel";
import React, { useState, useEffect } from "react";
import { ViewRequestWrapper } from "./ViewRequestStyled";
import ServiceDistributionTab from "../ServiceDistributionTab/ServiceDistributionTab";
import CustomerStatus from "../utilities/CustomerStatus/CustomerStatus";
import moment from "moment";
import AccordionComp, { Accordion } from "../utilities/Accordian/Accordian";
import {
  Constant,
  OpportunityType,
  NoOfRamsToolTip,
  samPricingToolTip,
  renewalToolTip,
  LocalStorageKeys,
  DiscountToolTip,
  SeatCountToolTip,
  CalculatedProducts,
  AllProductsEnum,
  PricingStructuresEnum,
  BankOfHoursComponentsEnum,
  isProductLikeBOH,
  isProductNotLikeBOH,
} from "../QuoteRequest/Content";
import NoteTable from "../utilities/NoteTable/NoteTable";
import SearchInput from "../utilities/SearchInput/SearchInput";
import Detail from "../utilities/Detail/Detail";
import Approval from "../utilities/Approval/Approval";
import BasicTable from "../utilities/BasicTable/BasicTable";
import QuoteDetail from "../QuoteDetail/QuoteDetail";
import ValidationTab from "../ValidationTab/ValidationTab";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Congiguration } from "../../Constants/AppConstants";
import {
  getQuoteDetails,
  getServiceDistribution,
  getUsersByRole,
  saveQuoteHistory,
  getQuoteHistory,
  saveNote,
  getQuotePricingDetails,
  getBlendedRevenueDistribution,
  updateQuoteStatus,
  downloadRFPFile,
  getQuoteDetailsForBankOfHours,
  saveBankOfHoursVariation,
  SaveQuoteCalculations,
  approveQuote,
  getPendingApprovalRoles,
  rejectQuote,
  validateQuote,
  checkApproversRequired,
  saveApprovalAssignments,
} from "../../Actions/QuoteAction";
import Notification from "../utilities/Notification/Notification";
import { isEmpty, set } from "lodash";
import ServiceDistribution from "./ServiceDistribution";
import FooterButtonsNotesApprovals from "./Footer";
import ApprovalWorkflowDialog from "./ApprovalWorkflowDialog";
import { QuoteStatus, UserRole, ProductsEnum } from "../QuoteRequest/Content";
import { Severity } from "../utilities/Notification/NotificationContent";
import closeIcon from "../../images/closeIcon.svg";
import checkIcon from "../../images/checkIcon.svg";
import quoteIcon from "../../images/qoute.svg";
import ObjectTable from "../utilities/ObjectTable/ObjectTable";
import {
  getDecryptedText,
  getEncryptedText,
  sendEmailToStakeHolders,
} from "../../Actions/CommonAction";
import {
  addOpportunityProduct,
  getCRMDataDetails,
  getCrmUploadData,
} from "../../Actions/CRMAction";
import { TextField, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { saveAs } from "file-saver";
import ScrollToTopButton from "../utilities/ScrollTopButton/ScrollToTopButton";
import Loader from "../utilities/Loader/Loader";
import { isJsonString } from "../../Helper/Helper";
import {
  GET_CRM_DATA,
  GET_LOGGED_USER_DETAILS,
} from "../../ActionTypes/ActionTypes";
import BOHServiceDistribution from "./BankOfHourDistribution/BOHServiceDistribution";
import CustomButton from "../utilities/Button/Button";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import SaveIcon from "@mui/icons-material/Save";
import { getLoggedUserDetails } from "../../Actions/UserAction";
import Discounts from "./Discounts";

let quoteHistory = {
  userId: 0,
  approverId: 0,
  quoteId: "",
  statusId: 0,
  companyId: 0,
  isDiscount: false,
};

let latestQuoteHistory = {
  userId: 0,
  approverId: 0,
  quoteId: "",
  statusId: 0,
  companyId: 0,
  isDiscount: false,
  createdDate: null,
};

let emailParams = {
  emailQuoteDetails: {},
  requestorEmail: "",
  requestorFirstName: "",
  requestorLastName: "",
  approverEmail: "",
  approverFirstName: "",
  approverLastName: "",
  isDiscount: false,
};

//Country List Table
const headerCells = [
  { id: "countryName", label: "Country" },
  { id: "headcount", label: "HeadCount" },
];

//price calculation
const PriceStructureheaderCells = [
  { id: "pricingStructureName", label: "" },
  { id: "allInPrice", label: "All in price" },
  //{ id: 'cost', label: 'Cost' },
  { id: "clinical", label: "Clinical" },
  { id: "wl", label: "WL" },
  { id: "lf", label: "LF" },
  { id: "web", label: "Web" },
];
//Distribution Table Data
const headerCellsDistribution = [
  { id: "id", label: "Product" },
  { id: "name", label: "Product" },
  { id: "product", label: "Product variation" },
  { id: "session", label: "Single session therapy" },
  { id: "person", label: "Scheduled in person sessions" },
  { id: "person", label: "Scheduled video sessions" },
  { id: "person", label: "Scheduled phone sessions" },
  { id: "session", label: "Work-Life Core" },
  { id: "session", label: "Work-Life Legal/Financial Referrals" },
  { id: "person", label: "Enhanced legal services" },
  { id: "person", label: "Enhanced Financial Services" },
];

//Notes Table Data
const noteHeader = ["No.", "With whom", "Date", "Time", "Message"];

//BOH Service Distribution Header
const bankOfHoursServiceDistributionHeader = [
  { id: "countryName", label: "Country" },
  { id: "components", label: "Component Selected" },
  { id: "hoursPerCountry", label: "Hours/Country" },
  { id: "headCount", label: "Headcount" },
  { id: "rateCurrency", label: "Rate Currency" },
  { id: "rate", label: "Rate / Hour" },
  { id: "rateRequestedCurrency", label: "Rate / hr Requested Currency" },
  { id: "revenueStage1ReqCurrency", label: "Total Revenue - Stage 1" },
  { id: "revenueStage2ReqCurrency", label: "Total Revenue - Stage 2" },
  { id: "revenueStage3ReqCurrency", label: "Total Revenue - Stage 3" },
  { id: "revenueStage4ReqCurrency", label: "Total Revenue - Stage 4" },
  { id: "revenueStage5ReqCurrency", label: "Total Revenue - Stage 5" },
];

//PATHWAYS/NPRTW/GWQ Service Distribution Header
const PathWaysNPRTWGWQServiceDistributionHeader = [
  { id: "countryName", label: "Country" },
  { id: "headCount", label: "Headcount" },
  { id: "rateCurrency", label: "Rate Currency" },
  { id: "rate", label: "Rate / Hour" },
  { id: "rateRequestedCurrency", label: "Rate / hr Requested Currency" },
  { id: "revenueStage1ReqCurrency", label: "Total Revenue - Stage 1" },
  { id: "revenueStage2ReqCurrency", label: "Total Revenue - Stage 2" },
  { id: "revenueStage3ReqCurrency", label: "Total Revenue - Stage 3" },
  { id: "revenueStage4ReqCurrency", label: "Total Revenue - Stage 4" },
  { id: "revenueStage5ReqCurrency", label: "Total Revenue - Stage 5" },
];

const ViewRequest = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [quote, setQuote] = useState({});
  const search = window.location.search;

  const useremail = sessionStorage.getItem(LocalStorageKeys.USEREMAIL);
  const loggedUserLocalStorage = isJsonString(
    sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER),
  )
    ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
    : null;

  let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);

  if (
    loggedUser !== undefined &&
    Object.keys(loggedUser).length === 0 &&
    loggedUser.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
      dispatch(getLoggedUserDetails(useremail))
        .then((response) => {
          loggedUser = response;
          //storing user login to reducer
          dispatch({
            type: GET_LOGGED_USER_DETAILS,
            payload: response,
          });
        })
        .catch((error) => {
          console.log(`userEmail : ${useremail} error : ${error}`);
        });
    } else {
      //storing user login to reducer
      dispatch({
        type: GET_LOGGED_USER_DETAILS,
        payload: loggedUser,
      });
    }
  } else if (
    loggedUser !== undefined &&
    Object.keys(loggedUser).length !== 0 &&
    loggedUser.constructor === Object &&
    loggedUserLocalStorage !== null
  ) {
    loggedUser = loggedUserLocalStorage;
    if (useremail?.toUpperCase() !== loggedUser?.user?.email?.toUpperCase()) {
      dispatch(getLoggedUserDetails(useremail))
        .then((response) => {
          loggedUser = response;
          const jsonUserData = JSON.stringify(response);
          sessionStorage.setItem(LocalStorageKeys.LOGGEDUSER, jsonUserData);
          //storing user login to reducer
          dispatch({
            type: GET_LOGGED_USER_DETAILS,
            payload: response,
          });
        })
        .catch((error) => {
          console.log(`userEmail : ${useremail} error : ${error}`);
        });
    }
  }

  const [utilizationDistributionRows, setUtilizationDistributionRows] =
    useState([]);
  const [
    utilizationDistributionComponents,
    setUtilizationDistributionComponents,
  ] = useState([]);
  const [
    utilizationDistributionCountries,
    setUtilizationDistributionByCountries,
  ] = useState([]);
  const [isApprovalWorkflowDialogVisible, setIsApprovalWorkflowDialogVisible] =
    useState(false);
  const [showAssignApproverDialog, setShowAssignApproverDialog] =
    useState(false);
  const [samLeadershipData, setSamLeadershipData] = useState([]);
  const [approverUsers, setApproverUsers] = useState([]);
  const [approver, setApprover] = useState();
  const [quoteHistoryValues, setQuoteHistoryValues] = useState({
    ...quoteHistory,
  });
  const [latestQuoteHistoryValues, setLatestQuoteHistoryValues] = useState({
    ...latestQuoteHistory,
  });
  const [isRejectedByPricingTeam, setIsRejectedByPricingTeam] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [value, setValue] = useState("0");
  const [isFFS, setIsFFS] = useState(false);
  const [pricingStructureLbl, setPricingStructureLbl] = useState("");
  const [pricingStructureUSDLbl, setPricingStructureUSDLbl] = useState("");
  const [pricingStructureVal, setPricingStructureVal] = useState("");
  const [pricingStructureUSDVal, setPricingStructureUSDVal] = useState("");
  const [showaddNotes, setshowaddNotes] = useState(false);
  const [showReject, setshowReject] = useState(false);
  const [approvalClose, setApproval] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [noteRows, setNoteRows] = useState(null);
  const [dialogError, setDialogError] = useState("");
  const [noteRow, setNoteRow] = useState(null);
  const [dialogText, setDialogText] = useState("");
  const [approverId, setApproverId] = useState(0);
  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [approverError, setApproverError] = useState("");
  const [quotePricingDetail, setQuotePricingDetail] = useState({});
  const [quoteDetailsBOH, setQuoteDetailsBOH] = useState([]);
  const [BOHRows, setBOHRows] = useState([]);
  const [saveBOHRows, setSaveBOHRows] = useState([]);
  const [BOHComponents, setBOHComponents] = useState([]);
  const [pricingList, setPricingList] = useState({
    pricingStructuresAllInPrices: [],
  });
  const [quotedRateReqCurrencyVal, setQuotedRateReqCurrencyVal] = useState("");
  const [quotedRateUSDVal, setQuotedRateUSDVal] = useState("");
  const [isDiscountExist, setIsDiscountExist] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [quoteRate, setQuoteRate] = useState("");
  const [quoteRateUSD, setQuoteRateUSD] = useState("");
  const [fileName, setFileName] = useState("");
  const [totalHeadCount, setTotalHeadCount] = useState(0);
  const [isQuoteDetailVariation, setIsQuoteDetailVariation] = useState(false);
  const [isBOHDistributionEditable, setIsBOHDistributionEditable] =
    useState(false);
  const [isBOHEditErrors, setIsBOHEditErrors] = useState(false);
  const [BOHEditErrors, setBOHEditErrors] = useState([]);
  const [allInPriceHeader, setAllInPriceHeader] = useState(
    PriceStructureheaderCells,
  );
  const [emailStatus, setEmailStatus] = useState([]);
  let newQuoteId = "";
  if (state?.quoteId) {
    newQuoteId = state?.quoteId;
  } else {
    newQuoteId = search?.replace("?quoteId=", "");
  }
  const [quoteId, setQuoteId] = useState(newQuoteId);
  const [dialogApproverRoles, setDialogApproverRoles] = useState([]);
  const [isOptionalApproval, setIsOptionalApproval] = useState(false);

  useEffect(() => {
    if (!dialogApproverRoles.length) return;
    loadApprovers(dialogApproverRoles);
  }, [dialogApproverRoles]);

  useEffect(() => {
    if (
      sessionStorage.getItem("quoteIdFromVisualize") !== "" &&
      sessionStorage.getItem("quoteIdFromVisualize") !== null &&
      sessionStorage.getItem("quoteIdFromVisualize") !== undefined
    ) {
      setQuoteId(sessionStorage.getItem("quoteIdFromVisualize"));
      sessionStorage.removeItem("quoteIdFromVisualize");
    }
    document.title = "View Request";
  }, []);

  useEffect(() => {
    if (pricingList && pricingList.length > 0) {
      setLoadingState(false);
    }
  }, pricingList);

  useEffect(() => {
    if (quotePricingDetail && quotePricingDetail.length > 0) {
      setLoadingState(false);
    }
  }, quotePricingDetail);

  useEffect(() => {
    if (quoteId) {
      getViewRequest(quoteId);
    }
    if (pricingList && pricingList.length > 0) {
      setLoadingState(false);
    }
    if (quotePricingDetail && quotePricingDetail.length > 0) {
      setLoadingState(false);
    }
  }, [quoteId]);
  useEffect(() => {
    if (quote.length) {
      setIsDiscountExist(quote.quoteDetails.discount !== 0);
      console.log("quote.discount", quote.quoteDetails.discount);
    }
  }, quote);

  const [pendingApproverRoles, setPendingApproverRoles] = useState([]);

  function getViewRequest(quoteId) {
    if (quoteId) {
      setLoadingState(true);
      dispatch(getQuoteDetails(quoteId))
        .then((data) => {
          if (
            data?.quoteDetails?.productId === AllProductsEnum.WELLNESSCOACHING
          ) {
            const wellnessCoachingllInPriceHeader = [
              { id: "pricingStructureName", label: "" },
              { id: "allInPrice", label: "All in price" },
              { id: "wellnessCoaching", label: "Wellness Coaching" },
            ];

            setAllInPriceHeader(wellnessCoachingllInPriceHeader);
          }

          if (isProductLikeBOH(data?.quoteDetails?.productId)) {
            setIsQuoteDetailVariation(true);
            getQuoteDetailsForBOH(quoteId);
          }

          setQuote({ ...data });
          getPengingApprovalRoles(quoteId, data?.quoteDetails?.quoteStatusId);
          getUtilizationDistribution(data.quoteDetails);
          setQuoteHistoryValues((prevValues) => ({
            ...prevValues,
            userId: loggedUser?.user?.id,
            approverId: approver,
            quoteId: data?.quoteDetails?.quoteId,
            statusId: data?.quoteDetails?.quoteStatusId,
            companyId: Congiguration.CompanyId,
          }));
          setNoteRows(data?.noteList);
          setNoteRow(data.noteList);
          setIsDiscountExist(data?.quoteDetails?.isDiscount);
          let totalHc = 0;
          data?.countryHeadCounts.map((countryHc) => {
            totalHc += countryHc.headcount;
          });
          if (totalHc) {
            setTotalHeadCount(totalHc);
          }
          if (data?.quoteDetails?.rfpFileName) {
            let splitedfilename = data?.quoteDetails?.rfpFileName.split("_");
            if (splitedfilename.length > 0) splitedfilename.shift();
            setFileName(splitedfilename.join("_"));
          }
          getPricingCalc(
            data.allInPrice,
            data.quoteDetails.pricingStructureId,
            data.quoteDetails.currencyCode,
            data.quoteDetails.pricingStructureName,
          );
          getRevenueDistribution(data?.quoteDetails);
          getQuotePricing(data?.quoteDetails?.quoteId);
          getCRMDataAndSaveToReducerAndSession(data);

          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
          setLoadingState(false);
        });

      console.log("logged user view quote", loggedUser);
    }
    //Get all quote history values
    dispatch(getQuoteHistory(quoteId))
      .then((data) => {
        if (data) {
          setLatestQuoteHistoryValues(data);
          console.log("Latest quote histories", data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  const getPengingApprovalRoles = (quoteId, statusId) => {
    dispatch(getPendingApprovalRoles(quoteId, statusId)).then((response) => {
      setPendingApproverRoles(response);
    });
  };

  async function getCRMDataAndSaveToReducerAndSession(QuoteDetailsData) {
    let result;
    await dispatch(
      getCRMDataDetails(QuoteDetailsData?.opportunityDetails.oppurtunityId),
    )
      .then((crmData) => {
        console.log("email link hit get opp details", crmData);
        const jsonCRMData = JSON.stringify(crmData);
        sessionStorage.setItem(
          LocalStorageKeys.CURRENTFETCHEDCRMDATA,
          jsonCRMData,
        );
        //storing CRM data to reducer
        dispatch({
          type: GET_CRM_DATA,
          payload: crmData,
        });

        if (
          (!sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) &&
            (sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) == null ||
              sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL) ==
                "null")) ||
          (isJsonString(
            sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL),
          ) &&
            JSON.parse(sessionStorage.getItem(LocalStorageKeys.CRMDATAINITIAL))
              ?.opportunityId !=
              QuoteDetailsData?.opportunityDetails.oppurtunityId)
        ) {
          const jsonCRMData = JSON.stringify(crmData);
          sessionStorage.setItem(LocalStorageKeys.CRMDATAINITIAL, jsonCRMData);
        }

        result = crmData;
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
    return result;
  }

  async function getQuotePricing(quoteId) {
    let result;
    setLoadingState(true);
    await dispatch(getQuotePricingDetails(quoteId))
      .then((detail) => {
        if (detail) {
          setQuotePricingDetail({ ...detail });
          console.log("pricing__", detail);
          result = detail;
          setLoadingState(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
    return result;
  }

  async function getQuoteDetailsForBOH(quoteId) {
    let result;
    setLoadingState(true);
    await dispatch(getQuoteDetailsForBankOfHours(quoteId))
      .then((detail) => {
        if (detail) {
          setQuoteDetailsBOH(detail);
          setBOHRows(detail?.quoteDetailsBankOfHours);
          setBOHComponents(detail?.components);
          console.log("BOH data", detail);
          result = detail;
        }
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
    return result;
  }

  async function getRevenueDistribution(quote) {
    setLoadingState(true);
    setBlendedRevenueLoader(true);
    let result;
    await dispatch(getBlendedRevenueDistribution(quote.quoteId))
      .then((data) => {
        if (data) {
          setPricingList({ ...data });

          const quotedRateCurrencyVal = data?.pricingStructuresAllInPrices.find(
            (x) => x.pricingStructureId == quote?.pricingStructureId,
          )?.allInPrice;

          const quotedRateUSDVal = data?.pricingStructuresAllInPrices.find(
            (x) => x.pricingStructureId == 100 + quote?.pricingStructureId,
          )?.allInPrice;

          setQuotedRateReqCurrencyVal(
            Number(quotedRateCurrencyVal?.toFixed(2)).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            }),
          );

          setQuotedRateUSDVal(
            Number(quotedRateUSDVal?.toFixed(2)).toLocaleString("en", {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            }),
          );
        }
        console.log("pricing list", data);
        result = data;
        setBlendedRevenueLoader(false);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
        setBlendedRevenueLoader(false);
      });
    return result;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let tabs;
  if (
    !Object.values(CalculatedProducts).includes(quote?.quoteDetails?.productId)
  ) {
    tabs =
      (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGVP)
        ? ["Overview"]
        : ["Overview"];
  } else {
    if (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
      loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
      loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) {
      if (
        isProductNotLikeBOH(quote?.quoteDetails?.productId) &&
        quote?.quoteDetails?.productId !==
          AllProductsEnum.ENHANCEDFINANCIALSERVICES &&
        quote?.quoteDetails?.productId !== AllProductsEnum.ENHANCEDLEGALSERVICES
      ) {
        tabs = ["Overview", "Quote Details", "Service Distribution"];
      } else if (isProductLikeBOH(quote?.quoteDetails?.productId)) {
        tabs = ["Overview", "Quote Details"];
      } else if (
        isProductNotLikeBOH(quote?.quoteDetails?.productId) &&
        (quote?.quoteDetails?.productId ===
          AllProductsEnum.ENHANCEDFINANCIALSERVICES ||
          quote?.quoteDetails?.productId ===
            AllProductsEnum.ENHANCEDLEGALSERVICES)
      ) {
        tabs = ["Overview", "Quote Details"];
      } else {
        tabs = ["Overview"];
      }
    } else {
      tabs = ["Overview"];
    }
  }
  const tabContents = [];
  //BOH header has Components and Others does not
  let variationHeader =
    quote?.quoteDetails?.productId ===
    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS
      ? bankOfHoursServiceDistributionHeader
      : PathWaysNPRTWGWQServiceDistributionHeader;

  function getPricingCalc(
    priceData,
    pricingStructureId,
    currencyCode,
    pricingStructureName,
  ) {
    setPricingStructureLbl(pricingStructureName);
    let alInPrice = {};
    if (priceData.length) {
      alInPrice = { ...priceData[priceData.length - 1] };
    }

    setPricingStructureUSDLbl(pricingStructureName + " USD");
    switch (pricingStructureId) {
      case PricingStructuresEnum.FFS:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FLATFEEQUARTERLY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );

        break;
      case PricingStructuresEnum.FFSPERCASE:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPERSESSION:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPERHOUR:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FLATFEEANNUAL:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.flatFeeAnnualTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.flatFeeAnnualTotalUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );

        break;
      case PricingStructuresEnum.FLATFEEMONTHLY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.flatFeeMonthlyTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.flatFeeMonthlyTotalUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PEPM:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.pepmTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(alInPrice?.pepmTotalUSD?.toFixed(2)).toLocaleString(
            "en",
            {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            },
          )}`,
        );
        break;
      case PricingStructuresEnum.PEPY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.pepyTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(alInPrice?.pepyTotalUSD?.toFixed(2)).toLocaleString(
            "en",
            {
              useGrouping: true,
              roundingMode: "trunc",
              minimumFractionDigits: 2,
            },
          )}`,
        );
        break;

      case PricingStructuresEnum.FFSDONOTUSE:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPERFULLDAY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPERPACKAGE:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PROBONO:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PEREMPLOYEEPERPOLICY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPER30MINUTECALL:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PERCENTOFFEESPROCESSEDMONTHLY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPER40MINUTECALL:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
      case PricingStructuresEnum.FFSPERHALFDAY:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PERPARTICIPANT:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FFSPERCALL:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.PERKIT:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FLATFEEONETIME:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;
      case PricingStructuresEnum.FLATFEE_BANKOFCASES:
        setPricingStructureVal(
          `${currencyCode}  ${Number(
            alInPrice?.ffsTotalReqCurrency?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setPricingStructureUSDVal(
          `USD  ${Number(
            alInPrice?.ffsTotalAnnualUSD?.toFixed(2),
          ).toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            minimumFractionDigits: 2,
          })}`,
        );
        setIsFFS(true);
        break;

      default:
        setPricingStructureVal("");
        setPricingStructureUSDVal("");
        break;
    }
  }
  function getUtilizationDistribution(quoteDetails) {
    setLoadingState(true);
    dispatch(
      getServiceDistribution(
        Congiguration.CompanyId,
        quoteDetails.productId,
        quoteDetails.productVariationId,
        quoteDetails.quoteId,
      ),
    )
      .then((data) => {
        bindServiceDistribution(data);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  }

  const handleChangeSearch = (text) => {
    setNoteRows(null);
    const tablesrows =
      text === ""
        ? [...noteRow]
        : noteRow.filter((item) =>
            Object.values(item).some(
              (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(text.toLowerCase()),
            ),
          );
    setNoteRows(tablesrows);
  };
  const statusList = [
    { id: QuoteStatus.CONTRACTED, name: "Contracted" },
    {
      id: QuoteStatus.CONTRACTEDRESERVATIONSMARGINCONCERNS,
      name: "Contracted w/ reservations: Margin concerns",
    },
    {
      id: QuoteStatus.CONTRACTEDRESERVATIONSCONTRACTEDTERMUTILIZATION,
      name: "Contracted w/ reservations: Contracted term – utilization",
    },
    {
      id: QuoteStatus.CONTRACTEDRESERVATIONSMINBILLINGNOTGUARANTEED,
      name: "Contracted w/ reservations: min. billing not guaranteed",
    },
    { id: QuoteStatus.QUOTECLOSED, name: "Quote closed" },
  ];
  const closestatus = {
    id: QuoteStatus.CLOSEDWITHOUTAPPROVAL,
    name: "Closed without approval",
  };
  const handleStatusChange = (event) => {
    setLoadingState(true);
    const statusId = event.target.value;
    dispatch(
      updateQuoteStatus(
        statusId,
        quote?.quoteDetails?.quoteId,
        loggedUser.user.id,
      ),
    )
      .then((data) => {
        console.log("statschanges");
        getViewRequest(quote?.quoteDetails?.quoteId);
        setNotificationMessage("Status Updated");
        setNotificationSeverity(Severity.SUCCESS);
        setShowNotification(true);
      })
      .catch((e) => {
        console.log(e);
        setLoadingState(false);
      });
  };
  //dialog box function
  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setApproverError("");
    setApproverId(value);
    console.log("approverId", value);
    setQuoteHistoryValues((prevValues) => ({
      ...prevValues,
      approverId: value,
      statusId: QuoteStatus.QUOTEPENDINGSAMLEADERSHIP,
    }));
  };
  const handleTextBoxChange = (value) => {
    if (value) {
      setDialogText(value);
    } else {
      setDialogText("");
    }
  };

  const loadApprovers = async (roles) => {
    try {
      const results = await Promise.all(
        roles.map(async (roleId) => {
          const users = await dispatch(getUsersByRole(roleId));

          return users.map((user) => ({
            ...user,
            roleId,
          }));
        }),
      );

      const mergedUsers = results.flat();

      setApproverUsers(mergedUsers);
    } catch (error) {
      console.error("Failed to load approvers", error);
    }
  };

  const availableApprovers = approverUsers;

  const handleAssignApprover = async () => {
    try {
      setLoadingState(true);
      setSelectedApprovers({});
      setDialogText("");
      setApproverError("");
      var quoteId = quote?.quoteDetails?.quoteId;
      var response = await dispatch(checkApproversRequired(quoteId));
      setDialogApproverRoles(response.pendingApproverRoles);
      setShowAssignApproverDialog(true);
    } catch (error) {
      setLoadingState(false);
      setNotificationMessage(
        "Error fetching approvers. Please try again or contact support.",
      );
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      console.error("Failed to check approvers", error);
    } finally {
      setLoadingState(false);
    }
  };

  const handleAssignApproverConfirm = async () => {
    try {
      setShowAssignApproverDialog(false);
      setLoadingState(true);
      const payload = {
        quoteId: quote?.quoteDetails?.quoteId,
        userId: loggedUser?.user?.id,
        notifyApprover: true,
        companyId: Congiguration.CompanyId,
        comments: dialogText,
        selectedApprovers: Object.values(selectedApprovers),
      };

      var response = await dispatch(saveApprovalAssignments(payload));
      if (response.status === 200) {
        setSelectedApprovers({});
        setDialogText("");
        setNotificationMessage("Approver assigned successfully.");
        setNotificationSeverity(Severity.SUCCESS);
        setShowNotification(true);
        getViewRequest(quote?.quoteDetails?.quoteId);
      } else {
        setNotificationMessage("Failed to assign approver.");
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
      }
    } catch (error) {
      setNotificationMessage("Failed to assign approver.");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
    } finally {
      setLoadingState(false);
    }
  };
  //approval
  const handleApproveButtonClick = async () => {
    try {
      setLoadingState(true);
      setSelectedApprovers({});
      setDialogText("");
      setApproverError("");
      const payload = {
        quoteId: quote?.quoteDetails?.quoteId,
        userId: loggedUser?.user?.id,
        roleId: loggedUser?.userRole?.[0]?.id,
        isDiscount: isDiscountExist,
        comments: dialogText,
        selectedApprovers: Object.values(selectedApprovers),
      };
      const response = await dispatch(validateQuote(payload));
      setDialogApproverRoles(response.pendingApproverRoles);
      setIsOptionalApproval(response.optionalApproval);
      setIsApprovalWorkflowDialogVisible(true);
    } catch (error) {
      setLoadingState(false);
      setNotificationMessage(
        "Error validating quote approval. Please try again or contact support.",
      );
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      console.error("Failed to validate quote approval", error);
    } finally {
      setLoadingState(false);
    }
  };

  const handleDialogConfirmApprove = () => {
    if (!dialogText || dialogText.trim() === "") {
      setDialogError("Please add a comment.");
      return;
    }

    dispatchApproveRequest(selectedApprovers);
    setSelectedApprovers({});
    setDialogText("");
    setIsApprovalWorkflowDialogVisible(false);
  };

  function validateAndProcessApprovers(selectedApprovers, isOptional) {
    const approverArray = Object.values(selectedApprovers);

    if (!approverArray || approverArray.length === 0) {
      return [];
    }

    const normalizedApprovers = approverArray
      .filter((approver) => approver && typeof approver === "object")
      .map((approver) => {
        const roleId = Number(approver.roleId);
        const rawUserId = approver.userId;

        let userId = null;
        if (typeof rawUserId === "string") {
          const trimmed = rawUserId.trim();
          userId = trimmed === "" ? null : trimmed;
        } else if (typeof rawUserId === "number") {
          userId =
            Number.isFinite(rawUserId) && rawUserId > 0 ? rawUserId : null;
        }

        return {
          roleId: Number.isInteger(roleId) && roleId > 0 ? roleId : null,
          userId,
        };
      });

    const validApprovers = normalizedApprovers.filter(
      (approver) => approver.roleId && approver.userId !== null,
    );

    if (!isOptional && validApprovers.length !== normalizedApprovers.length) {
      throw new Error(
        "All selected approvers must have valid userId and roleId",
      );
    }

    return validApprovers;
  }

  const dispatchApproveRequest = async (selectedApprovers) => {
    setLoadingState(true);
    try {
      // Validate and process selectedApprovers
      let processedApprovers = [];
      try {
        processedApprovers = validateAndProcessApprovers(
          selectedApprovers,
          isOptionalApproval,
        );
      } catch (validationError) {
        showNotification(Severity.ERROR, validationError.message);
        setLoadingState(false);
        return;
      }

      const payload = {
        quoteId: quote?.quoteDetails?.quoteId,
        userId: loggedUser?.user?.id,
        roleId: loggedUser?.userRole?.[0]?.id,
        isDiscount: isDiscountExist,
        comments: dialogText,
        selectedApprovers: processedApprovers, // Send validated approvers or empty array
      };

      const response = await dispatch(approveQuote(payload));

      if (response?.payload?.requiresMoreApprovals) {
        setNotificationMessage(
          `Waiting for approvals from ${response.payload.pendingApproverRoles.join(", ")}`,
        );
      } else {
        setNotificationMessage("Approval successful");
      }

      setNotificationSeverity(Severity.SUCCESS);
      setShowNotification(true);
      getViewRequest(payload.quoteId);
    } catch (err) {
      console.error(err);
      setLoadingState(false);
      setNotificationMessage("Approval failed");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
    } finally {
      setLoadingState(false);
    }
  };

  const handleRejectDialogConfirm = async () => {
    if (!dialogText || dialogText.trim() === "") {
      setDialogError(Content.REQUIREDERROR);

      return;
    }
    setLoadingState(true);
    setshowReject(false);
    try {
      const payload = {
        quoteId: quote?.quoteDetails?.quoteId,

        userId: loggedUser?.user?.id,

        roleId: loggedUser?.userRole?.[0]?.id,

        comments: dialogText,
      };

      const response = await dispatch(rejectQuote(payload));

      setDialogText("");

      getViewRequest(payload.quoteId);

      setNotificationMessage(
        response?.payload?.message || "Quote rejected successfully",
      );

      setNotificationSeverity(Severity.SUCCESS);

      setShowNotification(true);
    } catch (err) {
      console.error(err);
      setLoadingState(false);
      setNotificationMessage("Reject failed");

      setNotificationSeverity(Severity.ERROR);

      setShowNotification(true);
    } finally {
      setLoadingState(false);
    }
  };

  function closeConfirm() {
    setApproval(false);
    setNotificationMessage(
      "Quote was succesfully approved and assigned to SAM Leadership!",
    );
    setNotificationSeverity(Severity.SUCCESS);
    setShowNotification(true);
    navigate("/");
  }
  function closeApprovalWorkflowDialog() {
    setApproverError("");
    setDialogError("");
    setDialogText("");
    setSelectedApprovers({});
    setApproverId(0);
    setIsApprovalWorkflowDialogVisible(false);
  }
  //notification
  const closeNotificationPopup = () => {
    setShowNotification(false);
  };
  //notes

  function closeNotesDialog() {
    setshowaddNotes(false);
  }
  const handleAddNote = () => {
    setshowaddNotes(true);
  };
  const handleAddNewNote = () => {
    if (dialogText) {
      let newNote = {
        message: dialogText,
        companyId: Congiguration.CompanyId,
        userId: loggedUser.user.id,
        quoteId: quote?.quoteDetails?.quoteId,
      };
      // setshowaddNotes(false);
      // setNoteRows(null);
      setLoadingState(true);
      dispatch(saveNote(newNote))
        .then((data) => {
          console.log(newNote, "saveNote");
          //getViewRequest(quote?.quoteDetails?.quoteId)
          setNoteRows(data);
          setNoteRow(data);
          setLoadingState(false);
        })
        .catch((e) => {
          console.log(e);
        });

      setshowaddNotes(false);
    }
    setDialogText("");
  };
  //Reject
  const handleReject = () => {
    setshowReject(true);
  };
  function closeRejectDialog() {
    setshowReject(false);
  }

  const handleModifyClick = () => {
    setLoadingState(true);
    navigate("/quoterequest", {
      state: {
        quoteId: quote?.quoteDetails?.quoteId,
        requestType: "Edit",
      },
    });
  };

  const handleError = (err) => {
    console.log("error received in viewRequest: ", err);
  };

  function bindServiceDistribution(utilizationDistributionData) {
    const utilizationDistributionSet = new Set();
    const uniqueUtilizationDistributionKeys =
      utilizationDistributionData.utilizationDistributions.filter((item) => {
        const duplicate = utilizationDistributionSet.has(item.countryId);
        utilizationDistributionSet.add(item.countryId);
        return !duplicate;
      });

    setUtilizationDistributionByCountries(uniqueUtilizationDistributionKeys);
    setUtilizationDistributionComponents(
      utilizationDistributionData.components,
    );
    setUtilizationDistributionRows([
      ...utilizationDistributionData.utilizationDistributions,
    ]);
  }
  const handledownload = () => {
    dispatch(downloadRFPFile(quote.quoteDetails.rfpFileName))
      .then((data) => {
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const file = new Blob([data]);
          saveAs.saveAs(file, fileName);
        }
        console.log("save srv dist", data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const handleBOHTextChange = (countryId, value) => {
    console.log("countryId", countryId);
    console.log("value", value);
    let isError = false;
    let errorArray = [...BOHEditErrors];
    if (
      !value ||
      isNaN(value) ||
      value === "" ||
      !/^\d+(\.\d{1,6})?$/.test(parseFloat(value))
    ) {
      setNotificationMessage("Please enter a valid rate/hr number!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      isError = true;
      errorArray.push(countryId);
      setBOHEditErrors(errorArray);
    } else {
      isError = false;
      const updatedErrorArray = errorArray?.filter((x) => x !== countryId);
      setBOHEditErrors(updatedErrorArray);
    }

    setIsBOHEditErrors(isError);
    let currentBOHRows = [...BOHRows];

    const editedRowObj = currentBOHRows.find(
      (row) => row.countryId === countryId,
    );
    editedRowObj.rate =
      value !== "" && !isNaN(parseFloat(value)) ? value : value;
    const index = currentBOHRows.findIndex(
      (row) => row.countryId === countryId,
    );
    currentBOHRows.splice(index, 1, editedRowObj);

    if (!isError) {
      const currentSaveBOHRows = [...saveBOHRows];

      if (currentSaveBOHRows && currentSaveBOHRows.length > 0) {
        const index = currentSaveBOHRows.findIndex(
          (row) => row.countryId === countryId,
        );

        if (index != -1) {
          currentSaveBOHRows.splice(index, 1, editedRowObj);
        } else {
          currentSaveBOHRows.push(editedRowObj);
        }
      } else {
        currentSaveBOHRows.push(editedRowObj);
      }
      console.log("currentSaveBOHRows", currentSaveBOHRows);
      setSaveBOHRows(currentSaveBOHRows);
    }

    setBOHRows(currentBOHRows);
  };

  function handleEditBOHQuoteDetailClick() {
    setIsBOHDistributionEditable(true);
  }

  function handleSaveBOHQuoteDetailClick() {
    if (isBOHEditErrors) {
      setNotificationMessage("Please correct the input error(s)!");
      setNotificationSeverity(Severity.ERROR);
      setShowNotification(true);
      setLoadingState(false);
      return false;
    }

    setIsBOHDistributionEditable(false);
    setLoadingState(true);

    if (saveBOHRows && saveBOHRows.length > 0) {
      let bohSaveObj = {
        bankOfHoursTypes: [],
        quoteId: quote?.quoteDetails?.quoteId,
        companyId: Congiguration.CompanyId,
        userId: loggedUser?.user?.id,
      };

      saveBOHRows.map((row) => {
        bohSaveObj.bankOfHoursTypes.push({
          countryId: row?.countryId,
          ratePerHour: row?.rate,
        });
      });

      dispatch(saveBankOfHoursVariation(bohSaveObj))
        .then((data) => {
          console.log("save BOH variation", data);
          const saveQuoteCalculationObj = {
            quoteId: quote?.quoteDetails?.quoteId,
            userId: loggedUser?.user?.id,
          };
          dispatch(SaveQuoteCalculations(saveQuoteCalculationObj))
            .then((data) => {
              console.log("save QuoteCalculations", data);
              getViewRequest(quote?.quoteDetails?.quoteId);
              setNotificationMessage("Quote details saved successfully!");
              setNotificationSeverity(Severity.SUCCESS);
              setShowNotification(true);
              setLoadingState(false);
            })
            .catch((e) => {
              console.log("error saving QuoteCalculations", e);
              setLoadingState(false);
            });
        })
        .catch((e) => {
          console.log("error saving BOH variation", e);
          setLoadingState(false);
        });
    } else {
      setNotificationMessage("No changes to save!");
      setNotificationSeverity(Severity.INFO);
      setShowNotification(true);
      setLoadingState(false);
    }
  }

  const getQuoteStatusList = (quoteStatusId, statusList) => {
    return quoteStatusId === QuoteStatus.QUOTEAPPROVED
      ? statusList.filter((status) => status.id !== QuoteStatus.QUOTECLOSED)
      : statusList;
  };

  const isQuoteEditable = () => {
    return (
      (loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER || 
        loggedUser?.userRole[0]?.id === UserRole.PRICINGVP) &&
      (quote?.quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGTEAM || 
        quote?.quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGMANAGER || 
        quote?.quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVP ||
        quote?.quoteDetails?.quoteStatusId === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP)
    );
  };

  const [loadingState, setLoadingState] = useState(false);
  const [blendedRevenueLoader, setBlendedRevenueLoader] = useState(false);
  return (
    <>
      <ViewRequestWrapper>
        <Banner
          Heading={Content.BANNER_HEADING}
          Paragraph={Content.BANNER_PARAGRAPH}
          showBreadcrumb={true}
          breadcrumbName={Content.BREADCRUMB_NAME}
        />
        {!isEmpty(quote) && (
          <Container maxWidth="xl">
            <TabPannel
              value={value}
              handleChange={handleChange}
              tabs={tabs}
              tabContents={tabContents}
              isDisabled={loadingState}
            />
            {value === "0" && (
              <Box className="boxWrapper">
                <div className="quoteInput">
                  <img src={quoteIcon} alt="img" />
                  <h4>Quote Request</h4>
                  <div className="quoteText">
                    <TextField
                      size="small"
                      className="inputField"
                      value={quote?.quoteDetails?.quoteName}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>
                </div>

                <Box className="boxContainer">
                  <CustomerStatus
                    quoteDetails={quote?.quoteDetails}
                    opportunityDetails={quote?.opportunityDetails}
                    statusList={getQuoteStatusList(
                      quote?.quoteDetails?.quoteStatusId,
                      statusList,
                    )}
                    status={closestatus}
                    handleSelectChange={handleStatusChange}
                    isPricingTeam={
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGTEAM || 
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGMANAGER ||
                      loggedUser?.userRole[0]?.id === UserRole.PRICINGVP
                    }
                    isSamLeadership={
                      loggedUser?.userRole[0]?.id ===
                        UserRole.SAMLEADERSHIPTEAM ||
                      loggedUser?.userRole[0]?.id ===
                        UserRole.SAMLEADERSHIPTEAMLEVEL3
                    }
                    isInitialUser={
                      loggedUser?.user?.id === quote?.quoteDetails?.createdBy
                    }
                    headCount={totalHeadCount}
                  />
                </Box>
                <Box className="detailWrapper d-flex">
                  <Box className="otherDetail">
                    <h3>Other Details</h3>
                    <Detail
                      quote={quote}
                      quotedRateReqCurrency={pricingStructureVal}
                      quotedRateUSD={pricingStructureUSDVal}
                      loggedUser={loggedUser}
                    />
                  </Box>
                </Box>
                {/* <Box className="approvalDiscountContainer">
                  
                </Box> */}
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#1B4A83",
                        fontSize: "20px",
                        textAlign: "start",
                        fontWeight: "600",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                      }}
                    >
                      Approvals
                    </Typography>
                    <Approval
                      approvalAssignments={quote?.approvalAssignments}
                      handleAssignApprover={handleAssignApprover}
                      quoteStatus={quote?.quoteDetails?.quoteStatusId}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="h3"
                      sx={{
                        color: "#1B4A83",
                        fontSize: "20px",
                        textAlign: "start",
                        fontWeight: "600",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                      }}
                    >
                      Discounts
                    </Typography>
                    <Discounts
                      quoteDiscount={quote?.quoteDetails?.discount}
                      bundleDiscount={quote?.quoteDetails?.bundleDiscount}
                    />
                  </Grid>
                </Grid>
                <Box className="quoteData">
                  <AccordionComp title="More Details" aria-required>
                    <Box className="formdataContainer">
                      {quote?.opportunityDetails?.oppurtunityType === "NEW" && (
                        <div className="formdataFieldFive">
                          <label>
                            {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL1}
                            <Tooltip
                              title={
                                <span className="tooltip">
                                  {renewalToolTip}
                                </span>
                              }
                            >
                              <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                          </label>
                          <TextField
                            className="formInputThree"
                            multiline
                            rows={3}
                            disabled
                            value={
                              quote?.quoteDetails?.existingPartneredClientInfo
                            }
                          />
                        </div>
                      )}
                      <div className="formdataFieldOne">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL1}</label>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE1}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          disabled
                          name="noOfLivesSavedByPartner"
                          value={quote?.quoteDetails?.noOfLivesSavedByPartner}
                        />
                      </div>
                      <div className="formdataFieldOne">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL2}</label>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE2}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          disabled
                          value={
                            quote?.quoteDetails
                              ?.totalPotentialHeadCountOutside !== ""
                              ? quote?.quoteDetails
                                  ?.totalPotentialHeadCountOutside
                              : ""
                          }
                        />
                      </div>
                      <div className="formdataFieldFour">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL3}{" "}
                          <span className="ifapplicable">
                            {Constant.IF_APPLICABLE}
                          </span>
                        </label>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE3}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        {fileName && (
                          <p className="fileName" onClick={handledownload}>
                            {fileName}
                          </p>
                        )}
                      </div>
                      <div className="formdataFiedlTwoTwo">
                        <label>
                          {Constant.SECOND_ACCORDIAN_LABEL4}{" "}
                          <span className="ifapplicable">
                            {Constant.IF_APPLICABLE}
                          </span>
                        </label>

                        <TextField
                          className="formInputTwoTwo"
                          multiline
                          rows={3}
                          disabled
                          name="formalRFPNotes"
                          value={quote?.quoteDetails?.formalRFPNotes}
                        />
                      </div>
                      <div className="formdataFieldOne">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL5}</label>
                        <TextField
                          className="formInput"
                          multiline
                          rows={3}
                          disabled
                          name="competitorsBidders"
                          value={quote?.quoteDetails?.competitorsBidders}
                        />
                      </div>
                      {quote?.opportunityDetails?.oppurtunityType === "NEW" && (
                        <div className="formdataFieldOne">
                          <label>{Constant.SECOND_ACCORDIAN_LABEL6} </label>
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE4}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                          <TextField
                            className="formInput"
                            disabled
                            multiline
                            rows={3}
                            value={quote?.quoteDetails?.pastQuotes}
                          />
                        </div>
                      )}
                      {quote?.opportunityDetails?.oppurtunityType === "NEW" && (
                        <div className="formdataFieldOne">
                          <label>{Constant.SECOND_ACCORDIAN_LABEL7} </label>
                          <span className="ifapplicable">
                            {Constant.IF_APPLICABLE}
                          </span>
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {Constant.TOOLTIP_TITLE5}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                          <TextField
                            className="formInputTwo"
                            disabled
                            multiline
                            rows={3}
                            value={
                              quote?.quoteDetails
                                ?.currentUtilizationWithOtherVendors
                            }
                          />
                        </div>
                      )}
                      {
                        <div className="formdataFieldTwo">
                          <label>
                            {Constant.SECOND_ACCORDIAN_LABEL8}
                            <Tooltip
                              title={
                                <span className="tooltip">
                                  {Constant.TOOLTIP_TITLE8}
                                </span>
                              }
                            >
                              <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                          </label>
                          <TextField
                            className="formInput"
                            disabled
                            value={moment(quote?.quoteDetails?.deadline).format(
                              "MM-DD-YYYY",
                            )}
                          />
                        </div>
                      }
                      <div className="formdataFieldTwo">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL9} </label>
                        <Tooltip
                          title={
                            <span className="tooltip">{NoOfRamsToolTip}</span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          disabled
                          value={quote?.quoteDetails?.noOfRAMs}
                        />
                      </div>
                      <div className="formdataFieldOne">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL10} </label>
                        <Tooltip
                          title={
                            <span className="tooltip">
                              {Constant.TOOLTIP_TITLE7}
                            </span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          multiline
                          rows={3}
                          disabled
                          value={quote?.quoteDetails?.locationRAMs}
                        />
                      </div>
                      {quote?.opportunityDetails?.oppurtunityType ===
                        "RENEWAL" && (
                        <div className="formdataFieldOne">
                          <label>
                            {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL2}
                          </label>
                          <TextField
                            className="formInput"
                            multiline
                            rows={3}
                            disabled
                            value={quote?.quoteDetails?.currentRateEffectiveOn}
                          />
                        </div>
                      )}
                      {quote?.opportunityDetails?.oppurtunityType ===
                        "RENEWAL" && (
                        <div className="formdataFieldSix">
                          <label>
                            {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL3}
                          </label>
                          <TextField
                            className="formInput"
                            multiline
                            rows={3}
                            disabled
                            value={
                              quote?.quoteDetails?.pastThreeYrRateHeadCount
                            }
                          />
                        </div>
                      )}
                      {quote?.opportunityDetails?.oppurtunityType ===
                        "RENEWAL" && (
                        <div className="formdataFieldSix">
                          <label>
                            {Constant.SECOND_ACCORDIAN_RENEWAL_LABEL4}
                            <Tooltip
                              title={
                                <span className="tooltip">
                                  {Constant.TOOLTIP_TITLE11}
                                </span>
                              }
                            >
                              <InfoOutlinedIcon className="infoIcon" />
                            </Tooltip>
                          </label>

                          <TextField
                            className="formInputFour"
                            multiline
                            rows={3}
                            disabled
                            name="annualUtilizationThreeYrs"
                            value={
                              quote?.quoteDetails?.annualUtilizationThreeYrs
                            }
                          />
                        </div>
                      )}
                      <div className="formdataFieldOne">
                        <label>{Constant.SECOND_ACCORDIAN_LABEL11} </label>
                        <Tooltip
                          title={
                            <span className="tooltip">{samPricingToolTip}</span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          multiline
                          rows={3}
                          disabled
                          value={
                            quote?.quoteDetails?.samPriceRecommendAssumption
                          }
                        />
                      </div>
                      <div className="formdataFieldTwoThree">
                        <label>{Constant.DISCOUNT} </label>
                        <Tooltip
                          title={
                            <span className="tooltip">{DiscountToolTip}</span>
                          }
                        >
                          <InfoOutlinedIcon className="infoIcon" />
                        </Tooltip>
                        <TextField
                          className="formInput"
                          disabled
                          value={quote?.quoteDetails?.discount}
                        />
                      </div>
                      {!Object.values(CalculatedProducts).includes(
                        quote?.quoteDetails?.productId,
                      ) && (
                        <div className="formdataFieldTwoThree">
                          <label>{Constant.SEATCOUNT} </label>
                          <Tooltip
                            title={
                              <span className="tooltip">
                                {SeatCountToolTip}
                              </span>
                            }
                          >
                            <InfoOutlinedIcon className="infoIcon" />
                          </Tooltip>
                          <TextField
                            className="formInput"
                            disabled
                            value={quote?.quoteDetails?.seatCount}
                          />
                        </div>
                      )}
                      {!Object.values(CalculatedProducts).includes(
                        quote?.quoteDetails?.productId,
                      ) && (
                        <div className="formdataFieldTwoThree">
                          <label>{Constant.HOURS} </label>
                          <TextField
                            className="formInput"
                            disabled
                            value={quote?.quoteDetails?.hours}
                          />
                        </div>
                      )}
                      {isProductLikeBOH(quote?.quoteDetails?.productId) && (
                        <div className="formdataFieldFive">
                          <label>{Constant.ADDITIONALNOTES} </label>
                          <TextField
                            className="formInputThree"
                            disabled
                            multiline
                            rows={3}
                            value={quote?.quoteDetails?.additionalNotes}
                          />
                        </div>
                      )}
                    </Box>
                  </AccordionComp>
                </Box>
                <Box className="countryList">
                  <AccordionComp title="Country List" aria-required>
                    <Box className="countryTable">
                      <BasicTable
                        headerCells={headerCells}
                        rows={quote.countryHeadCounts}
                      />
                    </Box>
                  </AccordionComp>
                </Box>
                {Object.values(CalculatedProducts).includes(
                  quote?.quoteDetails?.productId,
                ) &&
                  quote?.quoteDetails?.productVariationId !== 0 &&
                  utilizationDistributionCountries.length > 0 && (
                    <Box className="distribution">
                      <AccordionComp
                        title="Utilization Distribution"
                        aria-required
                      >
                        <Box className="distributionTable">
                          <ServiceDistribution
                            headers={utilizationDistributionComponents}
                            rows={utilizationDistributionRows}
                            countrlist={quote.countryHeadCounts}
                            countries={utilizationDistributionCountries.sort(
                              (a, b) =>
                                a.countryName.localeCompare(b.countryName),
                            )}
                          />
                        </Box>
                      </AccordionComp>
                    </Box>
                  )}
                <Box className="priceCalculation">
                  <AccordionComp
                    title="Pricing Calculation (All in price)"
                    aria-required
                  >
                    {isFFS ||
                    (!isFFS &&
                      loggedUser?.userRole[0]?.id !== UserRole.PRICINGTEAM && loggedUser?.userRole[0]?.id !== UserRole.PRICINGMANAGER && loggedUser?.userRole[0]?.id !== UserRole.PRICINGVP) ||
                    (loggedUser?.userRole[0]?.id !== UserRole.PRICINGTEAM && loggedUser?.userRole[0]?.id !== UserRole.PRICINGMANAGER && loggedUser?.userRole[0]?.id !== UserRole.PRICINGVP &&
                      isFFS) ||
                    (isFFS &&
                      isProductLikeBOH(quote?.quoteDetails?.productId)) ||
                    (!isFFS &&
                      isProductLikeBOH(quote?.quoteDetails?.productId)) ? (
                      <Box className="calculationContainer">
                        <div className="calculationContent">
                          <div className="d-flex">
                            <div className="heading">
                              <Typography variant="h6">
                                {pricingStructureLbl}
                              </Typography>
                              <div className="pricing">
                                <span>{pricingStructureVal}</span>
                              </div>
                            </div>
                            <div className="heading">
                              <Typography variant="h6">
                                {pricingStructureUSDLbl}
                              </Typography>
                              <div className="pricing">
                                <span>{pricingStructureUSDVal}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Box>
                    ) : (
                      <Box className="countryTable">
                        <ObjectTable
                          headers={allInPriceHeader}
                          rows={pricingList?.pricingStructuresAllInPrices.filter(
                            (x) =>
                              x.pricingStructureId ==
                                quote?.quoteDetails?.pricingStructureId ||
                              x.pricingStructureId ==
                                100 + quote?.quoteDetails?.pricingStructureId,
                          )}
                        />
                      </Box>
                    )}
                  </AccordionComp>
                </Box>
                <Box className="Note">
                  <AccordionComp title="Notes" aria-required>
                    <Box className="noteTable">
                      <div className="searchInput">
                        <h5>Search Notes </h5>
                        <SearchInput
                          placeholder="Search"
                          onSearchChange={handleChangeSearch}
                        />
                      </div>
                      {noteRows && (
                        <NoteTable headers={noteHeader} rows={noteRows} />
                      )}
                    </Box>
                  </AccordionComp>
                </Box>
              </Box>
            )}
            {/* Content for the Quote Details tab */}

            {value === "1" && !isQuoteDetailVariation ? (
              <QuoteDetail
                quotePricing={quotePricingDetail}
                pricing={pricingList}
                quoteObj={quote.quoteDetails}
                loggedUser={loggedUser}
                updateCalculationsAndRefreshPage={getViewRequest}
              />
            ) : (
              value === "1" && (
                <div className="distribution">
                  {isQuoteEditable() && (
                    <Box className="viewTableContainer">
                      <div className="d-flex">
                        <Typography variant="h4">{}</Typography>
                        {!isBOHDistributionEditable ? (
                          <div className="editBtn">
                            <CustomButton
                              buttonName={Constant.EDIT}
                              icon={ModeEditIcon}
                              color="primary"
                              className="editBtn"
                              onClick={handleEditBOHQuoteDetailClick}
                            />
                          </div>
                        ) : (
                          <div className="buttonAlign">
                            <CustomButton
                              buttonName={Constant.SAVE}
                              icon={SaveIcon}
                              color="success"
                              className="saveBtn"
                              onClick={handleSaveBOHQuoteDetailClick}
                            />
                          </div>
                        )}
                      </div>
                    </Box>
                  )}
                  <BOHServiceDistribution
                    headers={variationHeader}
                    rows={BOHRows}
                    components={BOHComponents}
                    isEditable={isBOHDistributionEditable}
                    onTextChange={handleBOHTextChange}
                    productId={quote?.quoteDetails?.productId}
                    BOHEditErrors={BOHEditErrors}
                  />
                </div>
              )
            )}

            {value === "2" &&
              !isQuoteDetailVariation &&
              quote?.quoteDetails?.productId !==
                AllProductsEnum.ENHANCEDFINANCIALSERVICES &&
              quote?.quoteDetails?.productId !==
                AllProductsEnum.ENHANCEDLEGALSERVICES && (
                <ServiceDistributionTab
                  quoteDetails={quote.quoteDetails}
                  pricing={pricingList}
                  handleFunction={getViewRequest}
                />
              )}

            {/* Content for the Validation tab */}

            {value === "3" && <ValidationTab />}
          </Container>
        )}
        <ScrollToTopButton />
      </ViewRequestWrapper>

      <Box>
        <FooterButtonsNotesApprovals
          loggedInUser={loggedUser}
          quoteStatusId={quote?.quoteDetails?.quoteStatusId}
          createdBy={quote?.quoteDetails?.createdBy}
          isDiscountChanged={isDiscountExist}
          handleApproveClick={handleApproveButtonClick}
          handleAddNote={handleAddNote}
          handleReject={handleReject}
          handleModify={handleModifyClick}
          pendingApproverRoles={pendingApproverRoles}
        />
      </Box>
      {showNotification && (
        <Notification
          open={showNotification}
          onClose={closeNotificationPopup}
          message={notificationMessage}
          severity={notificationSeverity}
        />
      )}

      {showaddNotes && (
        <ApprovalWorkflowDialog
          dialogText={dialogText}
          show={showaddNotes}
          title={Content.NOTEBANNER}
          heading={Content.NOTEHEADING}
          imgsrc={checkIcon}
          popupType={Content.NOTE}
          handleTextBoxChange={handleTextBoxChange}
          handleConfirmClick={handleAddNewNote}
          handleCancelClick={closeNotesDialog}
        />
      )}
      {isApprovalWorkflowDialogVisible && (
        <ApprovalWorkflowDialog
          show={isApprovalWorkflowDialogVisible}
          title={Content.APPROVEBANNER}
          heading={Content.APPROVEHEADING}
          approverId={approverId}
          dialogText={dialogText}
          popupType={Content.APPROVE}
          showError={approverError}
          imgsrc={checkIcon}
          textboxError={dialogError}
          handleTextBoxChange={handleTextBoxChange}
          approverUsers={availableApprovers}
          selectedApprovers={selectedApprovers}
          setSelectedApprovers={setSelectedApprovers}
          handleConfirmClick={handleDialogConfirmApprove}
          handleCancelClick={closeApprovalWorkflowDialog}
          dialogApproverRoles={dialogApproverRoles}
          isOptionalApprover={isOptionalApproval}
        />
      )}
      {showAssignApproverDialog && (
        <ApprovalWorkflowDialog
          show={showAssignApproverDialog}
          title={Content.APPROVEBANNER}
          heading={Content.APPROVEHEADING}
          approverId={approverId}
          dialogText={dialogText}
          popupType={Content.APPROVE}
          showError={approverError}
          imgsrc={checkIcon}
          textboxError={dialogError}
          handleTextBoxChange={handleTextBoxChange}
          approverUsers={availableApprovers}
          selectedApprovers={selectedApprovers}
          setSelectedApprovers={setSelectedApprovers}
          handleConfirmClick={handleAssignApproverConfirm}
          handleCancelClick={() => setShowAssignApproverDialog(false)}
          dialogApproverRoles={dialogApproverRoles}
          isOptionalApprover={isOptionalApproval}
        />
      )}
      {approvalClose && (
        <ApprovalWorkflowDialog
          show={approvalClose}
          imgsrc={checkIcon}
          title={Content.CONFIRMBANNER}
          heading={
            isDiscountExist ||
            loggedUser?.userRole[0].id === UserRole.SAMLEADERSHIPTEAM ||
            loggedUser?.userRole[0].id === UserRole.SAMLEADERSHIPTEAMLEVEL3
              ? Content.CONFIRMHEADING_POSTDISCOUNT
              : Content.CONFIRMHEADING
          }
          popupType={Content.CONFIRM}
          handleConfirmClick={closeConfirm}
        />
      )}
      {showReject && (
        <ApprovalWorkflowDialog
          show={handleReject}
          title={Content.REJECTBANNER}
          heading={Content.REJECTHEADING}
          imgsrc={closeIcon}
          handleTextBoxChange={handleTextBoxChange}
          popupType={Content.REJECT}
          dialogText={dialogText}
          handleCancelClick={closeRejectDialog}
          handleConfirmClick={handleRejectDialogConfirm}
        />
      )}
      {loadingState && <Loader open={loadingState} />}
      {blendedRevenueLoader && <Loader open={blendedRevenueLoader} />}
    </>
  );
};

export default ViewRequest;
